var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenderMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.025 1.5562C17.025 1.1437 16.6875 0.731201 16.2375 0.731201H11.925C11.475 0.731201 11.1375 1.0687 11.1375 1.5187C11.1375 1.9687 11.475 2.3062 11.925 2.3062H14.3625L10.9875 5.6812C9.9 4.8187 8.5125 4.2937 7.0125 4.2937C3.4875 4.3687 0.5625 7.2562 0.5625 10.8187C0.5625 14.3812 3.4875 17.2687 7.0125 17.2687C10.5375 17.2687 13.4625 14.3812 13.4625 10.8187C13.4625 9.3187 12.9375 7.9687 12.075 6.8437L15.45 3.4687V6.0562C15.45 6.5062 15.7875 6.8437 16.2375 6.8437C16.6875 6.8437 17.025 6.5062 17.025 6.0562V1.5562ZM7.0125 15.6937C4.3125 15.6937 2.1375 13.5187 2.1375 10.8187C2.1375 8.1187 4.3125 5.9437 7.0125 5.9437C9.7125 5.9437 11.8875 8.1187 11.8875 10.8187C11.8875 13.5187 9.7125 15.6937 7.0125 15.6937Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenderMale);
export default __webpack_public_path__ + "static/media/GenderMale.c07360f355d2899190795d2f9be40496.svg";
export { ForwardRef as ReactComponent };